import useAlias from '@alias';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import {
  Box,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { modalHeaderStyles } from './styles';
import type { ModalHeaderProps } from './types';

const ModalHeader: React.FC<ModalHeaderProps> = React.memo(
  ({ incidentTimestamp, onRefresh, onClose, isFetching }) => {
    const theme = useTheme();
    const alias = useAlias();

    return (
      <DialogTitle sx={modalHeaderStyles.titleContainer}>
        <Box component='span'>
          <FormattedAlias id='Historical Temperature Data' />
          {incidentTimestamp && (
            <Typography
              component='span'
              variant='caption'
              sx={modalHeaderStyles.incidentCaption(theme)}
            >
              {' '}
              (<FormattedAlias id='From 2h before incident to now' />)
            </Typography>
          )}
        </Box>
        <Box sx={modalHeaderStyles.buttonContainer}>
          <Tooltip title={alias('Refresh data')}>
            <span>
              <IconButton
                aria-label={alias('refresh')}
                onClick={onRefresh}
                disabled={isFetching}
                sx={modalHeaderStyles.refreshButton(theme, isFetching)}
              >
                <RefreshIcon />
              </IconButton>
            </span>
          </Tooltip>
          <IconButton
            aria-label={alias('close')}
            onClick={onClose}
            sx={modalHeaderStyles.closeButton(theme)}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
    );
  },
);

ModalHeader.displayName = 'ModalHeader';

export default ModalHeader;
